import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { Segment } from '../../../../services/analytics-services/segment';
import { SHOPIFY_SUPPLIES_LINK_CLICKED } from '../../../../constants/analytics-events';
import { messages } from './supplies-card-container-messages';
import { type SuppliesDisplayLocation, SHIPSTATION_SUPPLIES_URL, UTM_PARAMS_MAP } from './supplies-page-constants';

type ShipStationSuppliesLinkProps = {
  source: SuppliesDisplayLocation;
  category?: string;
};

export const ShipStationSuppliesLink = ({ source, category }: ShipStationSuppliesLinkProps) => {
  const utmParams = UTM_PARAMS_MAP[source] ?? UTM_PARAMS_MAP.HOME;
  const href = `${SHIPSTATION_SUPPLIES_URL}?${utmParams}`;

  const handleClick = useCallback(() => {
    const payload = category ? { page: source, category } : { page: source };
    Segment.trackEvent(SHOPIFY_SUPPLIES_LINK_CLICKED, payload);
    window.open(href, '_blank', 'noopener,noreferrer');
  }, [source, category, href]);

  return (
    <Button onClick={handleClick} theme={THEME_CONSTANTS.link}>
      <FormattedMessage {...messages.shipStationSuppliesLinkText} />
    </Button>
  );
};
